import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import Spinner from "../common/spinner";
import { ToastContainer, toast } from "react-toastify";
import "./activeOrders.scss";
import * as service from "./activeOrdersServices";
import {
  timestampToDateYearAndTime,
  log,
  getMapIdBasedonEnvironment,
} from "../../helper/helper";

import ridingImage from "../../assets/riding.png";
import walkingImage from "../../assets/walking.png";
import cyclingImage from "../../assets/cycling.png";
import drivingImage from "../../assets/driving.png";
import origin from "../../assets/origin.png";
import destination from "../../assets/destination.png";
import { GoogleMap, Marker, Polyline } from "@react-google-maps/api";
import { Row, Col } from "antd";
import Select from "../common/select";
import Input from "../common/input";
import decodePolyline from "decode-google-map-polyline";

function ActiveOrders(props) {
  const [transports, setTransports] = useState([]);
  const [sourceTransports, setSourceTransports] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [cursorTransportId, setCursorTransportId] = useState("");
  const [isHidden, setBtnHidden] = useState(true);
  const [totalPaidBearers, setTotalPaidBearers] = useState(0);
  const [totalPaidCustomers, setTotalPaidCustomers] = useState(0);
  const [selectedIds, setSelectedIds] = useState([]);
  const [filter, setFilter] = useState("");
  const [targetSelected, setTargetSelected] = useState("");
  const [SourcePositions, setSourcePositions] = useState([]);
  const [positions, setPositions] = useState([]);
  const [map, setMap] = React.useState(null);

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (!user) {
        return props.history.replace("/login");
      }
      adminGetAllActiveTransport();
    });
  }, []);

  const onLoadBounds = (map) => {
    if (!map) {
      return;
    }
    const bounds = new window.google.maps.LatLngBounds();
    positions.forEach((child) => {
      bounds.extend(new window.google.maps.LatLng(child.lat, child.lng));
    });
    map.fitBounds(bounds);
    setMap(map);
  };

  const defaultMapOptions = {
    fullscreenControl: true,
  };

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  const containerStyle = {
    width: "100%",
    height: "50vh",
  };

  const options = {
    fillColor: "lightblue",
    fillOpacity: 1,
    strokeColor: "blue",
    strokeOpacity: 1,
    strokeWeight: 2,
    clickable: false,
    draggable: false,
    editable: false,
    geodesic: false,
    zIndex: 1,
  };

  const loadGoogleMap = () => {
    return (
      <GoogleMap
        mapContainerStyle={containerStyle}
        zoom={13}
        onLoad={onLoadBounds}
        onUnmount={onUnmount}
        defaultOptions={defaultMapOptions}
        options={{
          mapId: getMapIdBasedonEnvironment(),
        }}
      >
        {positions.map((marker) => (
          <Marker
            position={marker}
            key={marker.lat + marker.lng + Math.random()}
            icon={{
              url: marker.icon,
            }}
          />
        ))}
        {transports.map((trip, idx) => (
          <Polyline
            key={`polyline-${idx}`}
            path={decodePolyline(trip.overview_polyline)}
            options={options}
          />
        ))}
        <></>
      </GoogleMap>
    );
  };

  let target = [
    { id: "1", name: "Origin Address" },
    { id: "2", name: "Customer Name" },
    { id: "3", name: "Destination Address" },
    { id: "4", name: "State of Transport" },
    { id: "5", name: "Bearer Name" },
    { id: "6", name: "Assigned MoT" },
  ];

  useEffect(() => {
    const filtered =
      selectedIds.length > 0
        ? transports.filter((t) => selectedIds.includes(t.transport_id))
        : transports;

    const bearersTotal = filtered.reduce(
      (sum, t) => sum + (t.final_paid_to_rider || 0),
      0
    );

    const customersTotal = filtered.reduce(
      (sum, t) => sum + (t.transport_receivable_price || 0),
      0
    );

    setTotalPaidBearers(bearersTotal);
    setTotalPaidCustomers(customersTotal);
  }, [selectedIds, transports]);

  const renderSpinner = () => {
    if (isLoading) {
      return <Spinner />;
    }
  };

  const handleTransportDate = (time) => {
    return timestampToDateYearAndTime(time._seconds, time._nanoseconds);
  };

  const handleMapMarkerPositions = (list) => {
    let positionsData = [];
    for (const trip of list) {
      positionsData.push(
        {
          lat: trip.origin_geopoint._latitude,
          lng: trip.origin_geopoint._longitude,
          icon: origin,
          zIndex: 9,
        },
        {
          lat: trip.destination_geopoint._latitude,
          lng: trip.destination_geopoint._longitude,
          icon: destination,
          zIndex: 9,
        }
      );
    }
    setPositions(positionsData);
  };

  const adminGetAllActiveTransport = async () => {
    setLoading(true);
    try {
      const result = await service.adminGetAllActiveTransport(
        cursorTransportId
      );
      setLoading(false);
      log(result);
      if (result) {
        setLoading(false);
        switch (result.data.code) {
          case 200:
            const list = [...transports, ...result.data.transportList];
            setTransports(list);
            setSourceTransports(list);
            if (result.data.cursor_transport_id) {
              setCursorTransportId(result.data.cursor_transport_id);
              setBtnHidden(false);
            } else {
              setCursorTransportId("");
              setBtnHidden(true);
            }

            let positionsData = [];
            for (const trip of result.data.transportList) {
              positionsData.push(
                {
                  lat: trip.origin_geopoint._latitude,
                  lng: trip.origin_geopoint._longitude,
                  icon: origin,
                  zIndex: 9,
                },
                {
                  lat: trip.destination_geopoint._latitude,
                  lng: trip.destination_geopoint._longitude,
                  icon: destination,
                  zIndex: 9,
                }
              );
            }
            setPositions([...positions, ...positionsData]);
            setSourcePositions([...positions, ...positionsData]);
            return;
          case 401:
            toast.error(result.data.message);
            return props.history.replace("/login");
          case 500:
            return toast.error(result.data.message);
          default:
            return toast.error(result.data.message);
        }
      }
    } catch (error) {
      log(error);
      toast.error(error.message);
    }
    setLoading(false);
  };

  const handleBearerType = (bearer) => {
    switch (bearer) {
      case "driving":
        return (
          <div className="bearer">
            <img src={drivingImage} alt="rider" />
          </div>
        );
      case "riding":
        return (
          <div className="bearer">
            <img src={ridingImage} alt="rider" />
          </div>
        );
      case "cycling":
        return (
          <div className="bearer">
            <img src={cyclingImage} alt="cycle" />
          </div>
        );
      case "walking":
        return (
          <div className="bearer">
            <img src={walkingImage} alt="walk" />
          </div>
        );

      default:
        break;
    }
  };

  const handleSelectedRow = (transport) => {
    setSelectedIds((prev) =>
      prev.includes(transport.transport_id)
        ? prev.filter((id) => id !== transport.transport_id)
        : [...prev, transport.transport_id]
    );
  };

  const handleFilterData = (value) => {
    setFilter(value);
    if (value !== "") {
      switch (targetSelected) {
        case "Origin Address":
          const origin = sourceTransports.filter(
            (li) => li.origin_address.indexOf(value) !== -1
          );
          setTransports(origin);
          handleMapMarkerPositions(origin);
          break;
        case "Customer Name":
          const name = sourceTransports.filter(
            (li) =>
              (li.customer_given_name + " " + li.customer_last_name).indexOf(
                value
              ) !== -1
          );
          setTransports(name);
          handleMapMarkerPositions(name);
          break;
        case "Destination Address":
          const destination = sourceTransports.filter(
            (li) => li.destination_address.indexOf(value) !== -1
          );
          setTransports(destination);
          handleMapMarkerPositions(destination);
          break;
        case "State of Transport":
          const state = sourceTransports.filter(
            (li) => li.latest_status.indexOf(value) !== -1
          );
          setTransports(state);
          handleMapMarkerPositions(state);
          break;
        case "Bearer Name":
          const riderName = sourceTransports.filter(
            (li) =>
              (li.rider_given_name + " " + li.rider_last_name).indexOf(
                value
              ) !== -1
          );
          setTransports(riderName);
          handleMapMarkerPositions(riderName);
          break;
        case "Assigned MoT":
          const mot = sourceTransports.filter(
            (li) => li.bearer_type.indexOf(value) !== -1
          );
          setTransports(mot);
          handleMapMarkerPositions(mot);
          break;
        default:
          break;
      }
    } else {
      setTransports(sourceTransports);
      setPositions(SourcePositions);
    }
  };

  return (
    <div className="show-all-list data-server-list">
      <ToastContainer />
      {renderSpinner()}

      <div style={{ padding: "20px 0" }}>
        <Row gutter={16}>
          <Col span="12">
            <div
              style={{
                fontSize: 16,
                fontWeight: "bold",
                textAlign: "center",
                color: "#f00",
              }}
            >
              Total Paid to Bearers: {totalPaidBearers.toFixed(2)}
            </div>
          </Col>
          <Col span="12">
            <div
              style={{
                fontSize: 16,
                fontWeight: "bold",
                textAlign: "center",
                color: "#71cf9a",
              }}
            >
              Total Paid to Customers: {totalPaidCustomers.toFixed(2)}
            </div>
          </Col>
        </Row>
      </div>

      <h6>
        Found {transports.length} {transports.length > 1 ? "results" : "result"}
      </h6>
      {positions.length > 0 && <div className="map"> {loadGoogleMap()}</div>}
      <div className="filter-section">
        <div className="row">
          <div className="col-md-6">
            <Select
              name="target"
              options={target}
              onChange={(e) => {
                setTargetSelected(e.target.value);
                setFilter("");
                setTransports(sourceTransports);
              }}
              disabled={false}
              defaultValue="Select your Option"
              disabledDefaultValue={false}
              disableSelect={false}
            />
          </div>
          <div className="col-md-6">
            <Input
              placeHolder="filter list"
              type="String"
              name="message"
              value={filter}
              onChange={(e) => handleFilterData(e.target.value)}
            />
          </div>
        </div>
      </div>

      {transports.length > 0 && (
        <>
          <table className="table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Origin Address</th>
                <th>Customer Name</th>
                <th>Destination Address</th>
                <th>State of Transport</th>
                <th>Bearer Name</th>
                <th>Assigned MoT</th>
                <th>Final Paid by Customer</th>
                <th>Final Paid to Rider</th>
                <th>(More Details)</th>
              </tr>
            </thead>
            <tbody>
              {transports.map((transport) => (
                <tr
                  key={transport.transport_id}
                  onClick={() => handleSelectedRow(transport)}
                  style={{
                    backgroundColor: selectedIds.includes(
                      transport.transport_id
                    )
                      ? "#dee2e6"
                      : "transparent",
                    cursor: "pointer",
                  }}
                >
                  <td>{handleTransportDate(transport.time)}</td>
                  <td>{transport.origin_address}</td>
                  <td>
                    {transport.customer_given_name
                      ? transport.customer_given_name
                      : "" + " " + transport.customer_last_name
                      ? transport.customer_last_name
                      : ""}
                  </td>
                  <td>{transport.destination_address}</td>
                  <td>{transport.latest_status}</td>
                  <td>
                    {transport.rider_given_name
                      ? transport.rider_given_name
                      : "" + " " + transport.rider_last_name
                      ? transport.rider_last_name
                      : ""}
                  </td>
                  <td>{handleBearerType(transport.bearer_type)}</td>
                  <td>{"A$ " + transport.transport_receivable_price}</td>
                  <td>{"A$ " + transport.final_paid_to_rider}</td>
                  <td>
                    <button
                      onClick={() =>
                        props.history.push("/home/transportSingle", {
                          transportId: transport.transport_id,
                        })
                      }
                      className="single-view"
                    >
                      view
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="load-more">
            <button
              hidden={isHidden}
              onClick={() => adminGetAllActiveTransport()}
            >
              Load More
            </button>
          </div>
        </>
      )}
    </div>
  );
}
export default ActiveOrders;
